import { adsAssistantClientFetch } from "./adsAssistantClientHttp";
import type { AdsActivityFreshAchievement } from "./adsAssistantClientEngagement";

export const USER_ACHIEVEMENTS_BASE = "/api/ads-assistant/user-achievements";

export type UserAchievementsListResponse = {
  ok: true;
  user_id: string;
  display_name?: string;
  achievements: AdsActivityFreshAchievement[];
};

export async function fetchUserAchievements(params?: { userId?: string }) {
  const sp = new URLSearchParams();
  if (params?.userId) sp.set("user_id", params.userId);
  const q = sp.toString();
  return adsAssistantClientFetch<UserAchievementsListResponse>(
    q ? `${USER_ACHIEVEMENTS_BASE}?${q}` : USER_ACHIEVEMENTS_BASE,
    { method: "GET" },
  );
}

export async function revokeUserAchievement(achievementId: string) {
  return adsAssistantClientFetch<{ ok: true; achievement: AdsActivityFreshAchievement }>(USER_ACHIEVEMENTS_BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ achievementId, action: "revoke" }),
  });
}
